import React from 'react';
import { cn } from '@/lib/utils';

export type BadgeVariant = 'default' | 'success' | 'warning' | 'danger' | 'info';

export interface BadgeProps {
  variant?: BadgeVariant;
  children: React.ReactNode;
  className?: string;
}

const badgeStyles: Record<BadgeVariant, string> = {
  default:
    'bg-panel text-foreground border-neon-cyan/15',
  success:
    'bg-neon-green/10 text-neon-green border-neon-green/25',
  warning:
    'bg-neon-amber/10 text-neon-amber border-neon-amber/25',
  danger:
    'bg-neon-magenta/10 text-neon-magenta border-neon-magenta/25',
  info:
    'bg-neon-cyan/10 text-neon-cyan border-neon-cyan/25',
};

const Badge: React.FC<BadgeProps> = ({
  variant = 'default',
  children,
  className,
}) => {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium',
        badgeStyles[variant],
        className
      )}
    >
      {children}
    </span>
  );
};

export default Badge;
